import React from "react";
import { classificationResultCalculation } from "../education/data";

const MyResults = ({frequencyOfSymptoms,levelOfSeverity}) => {
  return (
    <div className="py-2 px-4 flex items-center justify-center border-[1px] border-REELTeal bg-teal-25 rounded-[10px] w-full max-w-max">
      <p className="text-body-lg text-REELTeal font-semibold ">
        My Results:{" "}
        {classificationResultCalculation(frequencyOfSymptoms, levelOfSeverity)}
      </p>
    </div>
  );
};

export default MyResults;
